/**
 * Componente de Filtros para Histórico
 */

import React from 'react';
import { Search } from 'lucide-react';
import type { HistoricoSource } from '../../../types/historico';

interface HistoricoFiltersProps {
  searchTerm: string;
  sourceFilter?: 'ALL' | HistoricoSource; // Não usado mais, mas mantido para compatibilidade
  onSearchChange: (searchTerm: string) => void;
  loading?: boolean;
}

export function HistoricoFilters({
  searchTerm,
  onSearchChange,
  loading = false
}: HistoricoFiltersProps) {
  return (
    <div className="space-y-2">
      {/* Busca */}
      <div className="relative lg:max-w-2xl">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar por arquivo, cliente, usuário..."
          disabled={loading}
          className="w-full min-h-[44px] pl-10 pr-3 py-2 bg-navy-800 border border-navy-700 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
        />
      </div>

      {/* Filtro de Origem removido - controlado pelas tabs */}
    </div>
  );
}

